import React from 'react';
import { SignInButton, UserButton, useUser } from '@clerk/clerk-react';

/**
 * Authentication Header Component
 * Shows sign-in button for guests, user button for authenticated users
 */
export const AuthButton: React.FC = () => {
  const { isSignedIn, user } = useUser();

  if (isSignedIn) {
    return (
      <div className="flex items-center gap-4">
        <span className="text-sm text-sand-700 hidden sm:block">
          {user.firstName ||
            user.username ||
            user.emailAddresses[0]?.emailAddress}
        </span>
        <UserButton
          afterSignOutUrl="/"
          appearance={{
            elements: {
              avatarBox: 'w-10 h-10',
            },
          }}
        />
      </div>
    );
  }

  return (
    <SignInButton mode="modal">
      <button className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors">
        Sign In
      </button>
    </SignInButton>
  );
};
